// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__v8_Ob","label":"CategoryService_label__1E6JO","location":"CategoryService_location__2GDKZ"};